// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"1c649df1","307":"45390668","358":"902e564c","423":"8b7bea31","429":"11841df8","749":"62fd4e23","787":"60ce6809"}[chunkId] + ".chunk.js";
};